const win = window;
{
  win.o_global ||= {};
  win.o_util ||= {};
}
const otto = win.otto ?? {};
const asExport = /*                      */ (namespace, fieldKey, defaultValue) => namespace[fieldKey] ?? defaultValue;
const customerSession = /*           */ asExport(otto, "customerSession");
const onCustomerSessionRefresh = /*           */ asExport(customerSession, "onCustomerSessionRefresh");
export {
  customerSession,
  onCustomerSessionRefresh
};
/*                                     */
